import { useControls } from "leva";

export interface SceneControlsConfig {
  autoRotate: boolean;
  autoRotateSpeed: number;
  cameraFov: number;
  ambientLightIntensity: number;
}

export interface SceneControlsOptions {
  defaultAutoRotate?: boolean;
  defaultAutoRotateSpeed?: number;
  defaultCameraFov?: number;
  defaultAmbientLightIntensity?: number;
  autoRotateSpeedRange?: [number, number];
  cameraFovRange?: [number, number];
  ambientLightIntensityRange?: [number, number];
}

export function useSceneControls(
  options: SceneControlsOptions = {},
): SceneControlsConfig {
  const {
    defaultAutoRotate = true,
    defaultAutoRotateSpeed = 0.1,
    defaultCameraFov = 45,
    defaultAmbientLightIntensity = 0.5,
    autoRotateSpeedRange = [0, 2],
    cameraFovRange = [15, 80],
    ambientLightIntensityRange = [0, 3],
  } = options;

  const config = useControls("Scene Settings", {
    autoRotate: { value: defaultAutoRotate },
    autoRotateSpeed: {
      value: defaultAutoRotateSpeed,
      min: autoRotateSpeedRange[0],
      max: autoRotateSpeedRange[1],
      step: 0.01,
    },
    cameraFov: {
      value: defaultCameraFov,
      min: cameraFovRange[0],
      max: cameraFovRange[1],
    },
    ambientLightIntensity: {
      value: defaultAmbientLightIntensity,
      min: ambientLightIntensityRange[0],
      max: ambientLightIntensityRange[1],
      step: 0.1,
    },
  });

  return config;
}
